import { Box, Typography } from "@mui/material";
import React from "react";
import Instructions from "./Instructions";
import { useSelector } from "react-redux";

const PreReadTab = () => {
  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <>
      <Instructions />
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        minHeight={"400px"}
        justifyContent={"center"}
      >
        <Typography variant="title" fontWeight={500}>
          {Translation?.NoPreReadContent}
        </Typography>
        <Typography color="secondary.light">
          {Translation?.TopicNoPreReadContent}
        </Typography>
      </Box>
    </>
  );
};

export default PreReadTab;
